import { MainLayout } from '@/widgets/layouts/main';
import { Article } from '@/shared/components/article';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
export const PublicOfferPage = () => {
  return <>
      <PageSeo title="Оферта" description={`${APP_TITLE} – деловой английский для работы и повседневной коммуникации.`} noindex />

      <Article tag="main" className="select-none">
        <h1 className="mb-20 text-center header-h1">Договор-оферта</h1>

        <section className="mx-auto mb-10 max-w-6xl">
          <h2 className="mb-4 header-h3">Публичная оферта (договор на оказание услуг)</h2>

          <ul className="list-none">
            <li>
              1.1 Данный документ является официальным предложением (публичной Офертой) Индивидуального предпринимателя
              Сладких Анны Святославовны (ИНН: 745312661384, ОГРНИП: 323745600057252 (в дальнейшем – Исполнитель) и
              содержит все существенные условия договора по оказанию услуг по проведению дистанционных занятий по
              английскому языку, предлагаемых любому физическому или юридическому лицу, именуемому в дальнейшем
              «Заказчик».
            </li>

            <li>
              1.2 Акцептом (принятием предложения заключить договор) является оплата Клиентом заказанных услуг путем
              предоплаты в порядке, определяемом настоящим Договором. Акцептирование Клиентом настоящего Договора
              означает, что он полностью согласен со всеми положениями настоящего Договора.
            </li>
            <li>
              1.3 Учитывая особый порядок заключения договора оказания услуг, Исполнитель уведомляет Заказчика о
              необходимости до момента осуществления действий по акцепту настоящей публичной оферты внимательно
              ознакомиться с текстом настоящей публичной оферты (включая все приложения). Если Заказчик не согласен с
              какими-либо условиями настоящей Оферты, Вы вправе не акцептировать настоящую Оферту. Акцепт настоящей
              публичной Оферты на иных условиях не допускается. В случае возникновения споров, распечатанный текст
              настоящей оферты и документы, подтверждающие оплату, будут являться доказательствами заключения договора
              на оказание услуг между Исполнителем и Заказчиком на условиях, изложенных в настоящей оферте.
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl">
          <h2 className="mb-4 header-h3">2. Термины и определения.</h2>

          <ul className="list-none">
            <li>2.1 В настоящей публичной Оферте нижеприведенные термины используются в следующем значении:</li>

            <li>
              2.1.1 Оферта – предложение юридическим и физическим лицам (Заказчикам) заключить с Исполнителем «Договор
              на оказание услуг по проведению занятий по английскому языку (далее - «Договор»), на условиях, изложенных
              в данном предложении и размещенное на сайте Исполнителя : https://enlerno.ru/.
            </li>

            <li>
              2.1.2. «Тарифы» — систематизированный объем услуг, условия, форма и период их оказания, а также стоимость;
              «Тарифы» доступны для ознакомления и выбора Заказчика на сайте Исполнителя (https://enlerno.ru/).
            </li>

            <li>
              2.1.3. Акцепт Оферты – полное и безоговорочное принятие Оферты Заказчиком, путем выбора и оплаты
              соответствующего «Тарифа». Акцепт Оферты означает заключение договора Оферты между Сторонами в
              соответствии с выбранным тарифом;
            </li>

            <li>
              2.1.4. Занятие – дистанционная консультация по английскому языку, проводимая Преподавателем для Заказчика
              посредством использования по усмотрению Преподавателя.
            </li>

            <li>
              2.1.5. Преподаватель – физическое лицо, непосредственно проводящий занятие с Заказчиком: и оказывающее
              услуги в соответствии с агентским договором.
            </li>

            <li>
              2.1.6. Агентский договор – договор, в соответствии с которым Исполнитель совершает юридические и иные
              действия, связанные с осуществлением поиска потенциальных Заказчиков для получения услуг от Преподавателя
              в виде Занятий.
            </li>

            <li>
              2.1.7. Платформа – программно-аппаратный комплекс по адресу https://study.enlerno.ru, используемый
              Исполнителем для организации консультаций (занятий) по английскому языку, ведения расписания и
              взаимодействия с Заказчиком. Платформа предоставляется на базе сервиса ProgressMe (ООО «ПрогрессМи») в
              модели white label. Платформа не является образовательной организацией и используется исключительно как
              инструмент оказания услуг по настоящему Договору.
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl">
          <h2 className="mb-4 header-h3">3. Предмет оферты.</h2>

          <ul className="list-none">
            <li>
              3.1. Предметом настоящей Оферты является оказание Преподавателем услуг по проведению занятий по
              английскому языку с помощью программного обеспечения, выбранного по усмотрению Преподавателя, а Заказчик
              обязуется принимать эти услуги и оплачивать их в соответствии с условиями, предусмотренными настоящим
              договором.
            </li>

            <li>
              3.2. Исполнитель имеет право в любой момент изменять содержание любого «Тарифа» и условия настоящей
              публичной Оферты в одностороннем порядке без предварительного согласования с Заказчиком, обеспечивая при
              этом публикацию измененных условий в сети Интернет по адресу https://enlerno.ru/. Измененные условия
              вступают в силу с момента их публикации.
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl">
          <h2 className="mb-4 header-h3">4. Права и обязанности сторон.</h2>
          <h2 className="mb-4 header-h3">4.1. Исполнитель обязуется:</h2>

          <ul className="list-none">
            <li>
              4.1.1. В согласованные Сторонами сроки оказать услуги Заказчику надлежащим образом, в соответствии с
              условиями Договора, заключенного посредством акцепта настоящей оферты и выбранным «Тарифом».
            </li>

            <li>
              4.1.2. Не разглашать конфиденциальную информацию и данные, предоставленные Заказчиком в связи с
              исполнением заключенного Договора.
            </li>
          </ul>

          <h2 className="mb-4 header-h3">4.2. Заказчик имеет право:</h2>

          <ul className="list-none">
            <li>
              4.2.1. Требовать от Исполнителя своевременного и полного оказания услуг в соответствии с условиями
              заключенного Договора.
            </li>
          </ul>

          <h2 className="mb-4 header-h3">4.3. Заказчик обязуется:</h2>

          <ul className="list-none">
            <li>
              4.3.1 Своевременно и полностью оплатить Исполнителю стоимость оказываемых услуг в порядке, в сроки и
              размере, установленными настоящей Офертой и условиями выбранного им «Тарифа».
            </li>

            <li>
              4.3.2. Предоставить Исполнителю все сведения и данные, необходимые для выполнения своих обязательств по
              заключенному Договору.
            </li>

            <li>
              4.3.3. Не разглашать конфиденциальную информацию и иные данные, предоставленные Исполнителем в связи с
              исполнением настоящей Оферты, не раскрывать и не разглашать такие факты или информацию (кроме информации
              общедоступного характера) какой-либо третьей стороне без предварительного письменного согласия
              Исполнителя.
            </li>

            <li>4.3.4. Присутствовать на всех согласованных Занятиях.</li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl">
          <h2 className="mb-4 header-h3">5. Порядок оказания услуг.</h2>

          <ul className="list-none">
            <li>
              5.1. Акцепт оферты Заказчиком возможен только после предварительного подтверждения Исполнителем
              возможности оказания услуг по выбранному Заказчиком «Тарифа» и в запрошенное Заказчиком время (период). С
              целью подтверждения такой возможности Заказчик до момента оплаты связывается с Исполнителем по телефону
              или иным средствам связи, указанным на https://enlerno.ru. Окончательный акцепт оферты (оплата
              соответствующего «Тарифа») производится Заказчиком после получения от Исполнителя указанного выше
              соответствующего подтверждения и согласования сторонами времени и условий.
            </li>

            <li>
              5.2. В целях оказания услуг по настоящему договору Исполнитель привлекает третьих физических лиц -
              Преподавателей. Взаимоотношение между Преподавателями, предоставляющими услуги Заказчику, регламентируются
              дополнительными соглашениями между ними и Заказчиком.
            </li>

            <li>
              5.3. Для организации консультаций Исполнитель вправе использовать Платформу https://study.enlerno.ru.
              Доступ Заказчика к Платформе предоставляется по приглашению Исполнителя на адрес электронной почты
              Заказчика. Иные средства связи и программное обеспечение для проведения занятий могут использоваться по
              согласованию Сторон либо по усмотрению Преподавателя.
            </li>

            <li>
              5.4. В соответствии с согласованным Сторонами графиком, Преподаватель связывается с Заказчиком и проводит
              Занятие.
            </li>

            <li>
              5.5. Перенос или отмена занятия Заказчиком могут быть осуществлены не позднее 5 (пяти) часов до начала
              занятия. Несоблюдение указанного срока приравнивается к неявке Заказчика на занятие и оплачивается
              Заказчиком в размере 50%.
            </li>

            <li>
              5.6. Сообщения о переносе/отмене занятий принимаются только в рабочие часы (9:00 до 20:00). Отправленные в
              другое время сообщения о переносе/отмене занятий считаются не принятыми.
            </li>

            <li>
              5.7. Для переноса/ отмены занятия Заказчик обязан связаться с Исполнителем по телефону, указанному в
              реквизитах Исполнителя в тексте настоящей оферты или по телефону, указанному на сайте
              https://enlerno.ru/english-lessons.
            </li>

            <li>
              5.8. Если в установленное графиком время Заказчик не выходит на Занятие, Преподаватель в течение 10 минут
              ожидает появления Заказчика. Если в результате связаться с Заказчиком не удается, Занятие считается
              пропущенным по вине Заказчика, не переносится на другое время и оплачивается Заказчиком в размере 100% в
              соответствии с п. 2. ст. 781 ГК РФ.
            </li>

            <li>
              5.9. Занятия, которые не состоялись по вине Преподавателя, переносятся без их потери на другое время по
              согласованию с Заказчиком.
            </li>

            <li>
              5.10. Заказчик обязуется не передавать третьим лицам данные для доступа к Платформе и соблюдать
              размещенные на Платформе Пользовательское соглашение и Согласие на обработку персональных данных, а также
              условия https://enlerno.ru/agreement
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl">
          <h2 className="mb-4 header-h3">6. Оплата услуг.</h2>

          <ul className="list-none">
            <li>6.1. Стоимость услуг определяется согласно выбранного Заказчиком «Тарифа».</li>

            <li>
              6.2. Стоимость «Тарифа» представлены без учета комиссионного сбора, устанавливаемого компаниями кредитных
              карт, терминалами оплаты и интернет провайдерами.
            </li>

            <li>
              6.3. «Тарифы» включают в себя стоимость, оказанных Преподавателем услуг по Договору и вознаграждение
              Исполнителя по Агентскому договору.
            </li>

            <li>
              6.4. Заказчик оплачивает услуги в виде 100% предоплаты от стоимости, указанной в соответствующем «Тарифе»,
              в срок не позднее, чем за один день до первого занятия в соответствии с выбранным Тарифом.
            </li>

            <li>
              6.5. Заказчик оплачивает услуги путем перечисления денежных средств на расчетный счет Исполнителя через
              сервис на сайте https://enlerno.ru/english-lessons или иным способом по согласованию с Исполнителем.
            </li>

            <li>
              6.6. Датой исполнения обязательств по перечислению денежных средств, считается дата поступления денежных
              средств на расчетный счет Исполнителя.
            </li>

            <li>
              6.7. В случае отказа Заказчиком от обучения по причине невыполнения Исполнителем обязательств по данному
              Договору, внесенная в качестве оплаты за курс сумма подлежит частичному возврату с учетом перерасчета
              проведенных Исполнителем занятий.
            </li>

            <li>
              6.8. В случае досрочного расторжения Заказчиком настоящего Договора, возврат денежных средств
              осуществляется Заказчику за вычетом стоимости проведенных занятий, суммы комиссии за возврат денежных
              средств Заказчику, а также за вычетом из суммы, подлежащей возврату суммы штрафных санкций за досрочное
              расторжение в размере 20% от оплаченной суммы и иных понесенных Исполнителем расходов. Способ возврата
              денежных средств выбирается по согласованию Сторон.
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl">
          <h2 className="mb-4 header-h3">7. Ответственность сторон.</h2>

          <ul className="list-none">
            <li>
              7.1. За неисполнение или ненадлежащее исполнение обязательств по настоящему Договору Стороны несут
              ответственность в соответствии с действующим законодательством РФ.
            </li>

            <li>
              7.2. Стороны принимают все необходимые меры для разрешения разногласий, возникших в процессе исполнения
              условий Оферты, путем переговоров.
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl">
          <h2 className="mb-4 header-h3">8. Сведения об Исполнителе:</h2>

          <div className="text-muted-foreground/80">
            <p>Название компании: ИП Сладких Анна Святославовна</p>
            <p>Режим работы: Пн.-Пт. 9:00 - 18:00</p>
            <p>Почтовый адрес: 454080 г.Челябинск, пр. Ленина 77-28</p>
            <p>Юридический адрес: 454080 г.Челябинск, пр. Ленина 77-28</p>
            <p>E-mail: {process.env.NEXT_PUBLIC_EMAIL_URL ?? ''}</p>

            <p>р/с №: 40802810701500513350</p>
            <p>БИК: 044525104</p>
            <p>Банк: ООО &ldquo;Банк Точка&rdquo;</p>

            <p>ИНН: 745312661384</p>
            <p>ОГРНИП: 323745600057252</p>
          </div>
        </section>
      </Article>
    </>;
};
PublicOfferPage.Layout = MainLayout;